import { useState } from 'react';
import { ModifierGroupInterface } from '../../services/exports/Interfaces';
import { BasketLineItem, BasketLineItemModifier } from '../../store/types';
import { CompiledModifier, CompiledProduct } from '../../providers/MenuProvider';

type SubItemState = {
  item: CompiledProduct | CompiledModifier;
  modifierGroup: ModifierGroupInterface;
};

type UseMenuItemModifiersProps = {
  scrollToModifierGroup(modifierGroupId: number): void;
};

const useMenuItemModifiers = (props: UseMenuItemModifiersProps) => {
  const { scrollToModifierGroup } = props;
  const [subItem, setSubItem] = useState<SubItemState | null>(null);

  const getSubLineItem = (lineItem: BasketLineItem | BasketLineItemModifier): BasketLineItemModifier => {
    return (
      lineItem.modifiers.find(
        (item) =>
          item.modifier_group_id === subItem.modifierGroup.id &&
          item.modifier_id === subItem.item.id &&
          item.modifier_type === subItem.item.type,
      ) ?? {
        modifiers: [],
        modifier_type: subItem.item.type,
        modifier_id: subItem.item.id,
        quantity: 1,
        modifier_group_id: subItem.modifierGroup.id,
      }
    );
  };

  const openSubItem = (item: CompiledProduct | CompiledModifier, modifierGroup: ModifierGroupInterface): void =>
    setSubItem({
      item,
      modifierGroup,
    });

  const closeSubItem = (): void => {
    const modifierGroupId = subItem?.modifierGroup?.id;

    setSubItem(null);

    modifierGroupId && scrollToModifierGroup && requestAnimationFrame(() => scrollToModifierGroup(modifierGroupId));
  };

  return {
    getSubLineItem,
    subItem,
    openSubItem,
    closeSubItem,
  };
};

export default useMenuItemModifiers;
